import Authorization from './Authorization';
import Futures from './Futures';
import News from './News';
import Quotations from './Quotations';
import Valorization from './Valorization';

export default new Map()
  .set('authorization', new Authorization())
  .set('futures', new Futures())
  .set('news', new News())
  .set('quotations', new Quotations())
  .set('valorization', new Valorization());
